export var CateringPackageEnum;
(function (CateringPackageEnum) {
    CateringPackageEnum[CateringPackageEnum["Package1"] = 1] = "Package1";
    CateringPackageEnum[CateringPackageEnum["Package2"] = 2] = "Package2";
    CateringPackageEnum[CateringPackageEnum["Package3"] = 3] = "Package3";
    CateringPackageEnum[CateringPackageEnum["Package4"] = 4] = "Package4";
    CateringPackageEnum[CateringPackageEnum["Package5"] = 5] = "Package5";
    CateringPackageEnum[CateringPackageEnum["Package6"] = 6] = "Package6";
})(CateringPackageEnum || (CateringPackageEnum = {}));
export const CateringPackageEnumDisplay = {
    [CateringPackageEnum.Package1]: 'catering.package1',
    [CateringPackageEnum.Package2]: 'catering.package2',
    [CateringPackageEnum.Package3]: 'catering.package3',
    [CateringPackageEnum.Package4]: 'catering.package4',
    [CateringPackageEnum.Package5]: 'catering.package5',
    [CateringPackageEnum.Package6]: 'catering.package6'
};
